"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BucketEdgeCollection = void 0;
class BucketEdgeCollection {
    constructor() {
        this._size = 0;
        this.buckets = new Array(26);
    }
    set(char, node) {
        const k = char - 97 /* LowerA */;
        // Only increment the size if we didn't already have a node corresponding to it.
        if (!this.buckets[k])
            this._size++;
        this.buckets[k] = node;
    }
    get(char) {
        const k = char - 97 /* LowerA */;
        if (k >= 0 && k < 26)
            return this.buckets[k];
    }
    get size() {
        return this._size;
    }
    *keys() {
        for (let i = 0; i < 26; i++) {
            if (this.buckets[i] !== undefined)
                yield i + 97 /* LowerA */;
        }
    }
    *values() {
        for (let i = 0; i < 26; i++) {
            if (this.buckets[i] !== undefined)
                yield this.buckets[i];
        }
    }
    *[Symbol.iterator]() {
        for (let i = 0; i < 26; i++) {
            if (this.buckets[i] !== undefined)
                yield [i + 97 /* LowerA */, this.buckets[i]];
        }
    }
}
exports.BucketEdgeCollection = BucketEdgeCollection;
